import axios from "axios";

const http = axios.create({
  baseURL: "/api",
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt");
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * Сброс сессии при истечении/невалидности JWT.
 * Сигнал от auth.middleware: { auth: false }.
 * /login не трогаем — там тоже auth: false при неверном пароле.
 */
export function attachAuthInterceptor(store) {
  http.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response && error.response.status;
      const data = error.response && error.response.data;
      const url = (error.config && error.config.url) || "";

      const isLogin = url.includes("/login");
      const isJwtExpired =
        !isLogin &&
        (status === 401 || status === 403) &&
        data &&
        data.auth === false;

      if (isJwtExpired && (localStorage.getItem("jwt") || store.state.auth)) {
        store.commit("UPDATE_AUTH", false);
        store.dispatch("clearIntervals");
        localStorage.removeItem("user");
        localStorage.removeItem("auth");
        localStorage.removeItem("jwt");
      }

      return Promise.reject(error);
    }
  );
}

export default http;
